export default {
  namespaced: true,
  state: {
    isSyncEnd: false
  },
  mutations: {
    SET_SYNC_END(state, data) {
      state.isSyncEnd = data;
    }
  }
};
